<template>
    <slot>
        <button
            :class="[buttonObj.isLast?'btn btn-accent rounded-full':'btn-text arrow-r']"
            :disabled="disabled"
            @click="(disabled)?'':nextService()"
        >
            {{ buttonObj.label }}
        </button>
    </slot>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { checkTransaction, getIsBenefitRisk } from '@/apis/system';
import routeName from '@/router/constant.js';
import { useStore } from 'vuex';
import aplCatlCode from '@/json/aplCatlCode';
import { addAndInsertService } from '@/utils/changeItems/insertService';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        isSubmitOk: {
            type: Boolean,
            default: false,
        },
        // 可以控制要抓取資料的時機點
        isGetButtonInfo: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click', 'update:isSubmitOk', 'update:isGetButtonInfo'],
    setup(props, { emit }) {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const aplCatl = computed(() => store.state.services.aplCatl);
        const buttonObj = ref({
            label: '下一步', router: routeName.CONFIRM_DATA, isLast: true,
        });
        // const buttonObj = ref({});
        const getButtonInfo = () => {
            const serviceList = store.state.services.serviceList;
            const index = serviceList.findIndex(i => i.transactionItemNo === route.meta.code);
            if (serviceList.length !== index + 1) {
                const nextService = serviceList[index + 1];
                buttonObj.value = {
                    label: nextService.transactionItemName,
                    router: nextService.routeName,
                    isLast: false,
                };
            } else {
                buttonObj.value = {
                    label: '下一步', router: routeName.CONFIRM_DATA, isLast: true,
                };
            }
        };
        getButtonInfo();
        watch(() => [route.meta.code, props.isGetButtonInfo], ([newName, newIsGetButtonInfo], [oldName, oldIsGetButtonInfo]) => {
            if ((newName !== oldName && route.name !== routeName.CONFIRM_DATA) || newIsGetButtonInfo) {
                getButtonInfo();
            }
            if (newIsGetButtonInfo) {
                emit('update:isGetButtonInfo', false);
            }
        });
        watch(() => props.isSubmitOk, (newVal) => {
            try {
                if (newVal) {
                    // 做到最後一項才執行
                    if (buttonObj.value.isLast && aplCatl.value === aplCatlCode.POLICY) {
                        // 是否需新增交易項目(項目需要重新填寫)
                        checkTransaction().then(async (res) => {
                            if (res.data.checkTransactionList.length > 0) {
                                const addItemArr = res.data.checkTransactionList.map(i => {
                                    // action= 'add' 新增選項，action＝edit存在選項 不知道未來
                                    // 目前是已有填寫的變更項目清空重填
                                    // if (i.action === 'add' || i.action === 'edit') {}
                                    store.dispatch('services/removeService', i.itemNo);
                                    return i.itemNo;
                                });

                                addAndInsertService(addItemArr, route.meta.code);
                            } else {
                                // 是否需要需高風險預告書
                                getIsBenefitRisk().then(res => {
                                    const nextServiceName = res.data?.risk ? routeName.RISK_NOTICE : routeName.CONFIRM_DATA;
                                    router.push({ name: nextServiceName });
                                });
                            }
                        });
                    } else {
                        router.push({ name: buttonObj.value.router });
                    }
                    emit('update:isSubmitOk', false);
                }
            } catch (e) {
                console.log('btnNext2: ', e);
            }
        }, { immediate: true });

        const nextService = () => {
            emit('click');
        };
        return { buttonObj, nextService };
    },
};
</script>
